import { render, staticRenderFns } from "./AwlSidenavItem.vue?vue&type=template&id=4a53a9c2&"
import script from "./AwlSidenavItem.vue?vue&type=script&lang=js&"
export * from "./AwlSidenavItem.vue?vue&type=script&lang=js&"
import style0 from "./AwlSidenavItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports